import ButtonComponent from "../../components/button/Button";
import ProgrammeComponent from "../../components/eventCard/ProgrammeComponent";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LazyImage from "../../components/image/LazyLoadImage";

const UpcomingPrograms = ({ programmes }) => {
  const [firstProgramme, setFirstProgramme] = useState();
  const [otherProgrammes, setOtherProgrammes] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 1024; // lg breakpoint
      if (programmes && programmes.length > 0) {
        if (isMobile) {
          setFirstProgramme(undefined);
          setOtherProgrammes(programmes);
        } else {
          setFirstProgramme(programmes[0]);
          setOtherProgrammes(programmes.slice(1));
        }
      }
    };

    handleResize(); // run on initial load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [programmes]);

  return (
    <div className="mb-32 mt-20">
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center space-y-5 lg:space-y-0">
        <div className="flex-1">
          <div className="text-2xl sm:text-4xl lg:text-5xl text-color-primary-dark1 font-semibold">
            Our Well Planned Programs From Beginner to Pro Hiker
          </div>
        </div>

        <div
          className="w-full lg:w-auto flex justify-start lg:justify-end"
          onClick={() => navigate("/programmes")}
        >
          <ButtonComponent name={"View All"} type={"view"} />
        </div>
      </div>

      {/* Desktop only section */}
      {firstProgramme && (
        <div className="my-16 rounded-lg hidden lg:block">
          <div className="relative h-[500px] w-full">
            <div className="h-full overflow-hidden flex justify-center items-center">
              <LazyImage
                src={firstProgramme?.displayImage}
                className="w-full h-full object-cover object-center rounded-lg"
              />
              {/* <img
                src={firstProgramme?.displayImage}
                alt="program"
                className="w-full h-full object-cover object-center rounded-lg"
              /> */}
            </div>

            <div className="absolute top-5 left-5 h-[95%] bg-color-white w-[50%] rounded-lg px-16 py-5 opacity-95">
              <div className="font-bold text-4xl my-5">
                {firstProgramme?.name}
              </div>
              <div>
                {firstProgramme?.description
                  ?.split(" ")
                  .slice(0, 30)
                  .join(" ") + "..."}
              </div>

              <div className="w-[70%] mt-10 px-12 py-5 rounded-lg relative border-[2px]">
                <div className="relative z-10 pb-5 border-b-[1px]">
                  <div className="text-color-primary-dark2 uppercase text-2xl my-3 font-bold">
                    {firstProgramme?.startDate && firstProgramme?.endDate && (
                      <>
                        {new Date(firstProgramme.startDate).toLocaleDateString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "long",
                            day: "2-digit",
                          }
                        )}{" "}
                        -{" "}
                        {new Date(firstProgramme.endDate).toLocaleDateString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "long",
                            day: "2-digit",
                          }
                        )}
                      </>
                    )}
                  </div>
                </div>

                <div className="relative z-10 py-3 border-b-[1px]">
                  <div className="text-color-gray-dark font-semibold uppercase text-xl pb-1">
                    No of Events
                  </div>
                  <div className="text-3xl text-color-gray-dark font-semibold">
                    {firstProgramme?.programmeAdventures?.length}
                  </div>
                </div>

                <div className="relative z-10 py-3 border-b-[1px]">
                  <div className="text-color-gray-dark font-semibold uppercase text-xl pb-1">
                    Period ({firstProgramme?.durationUnits})
                  </div>
                  <div className="text-3xl text-color-gray-dark font-semibold">
                    {firstProgramme?.duration}
                  </div>
                </div>

                <div
                  className="w-full my-5"
                  onClick={() => navigate(`/programmes/${firstProgramme?.id}`)}
                >
                  <ButtonComponent
                    name={"View Programme"}
                    type={"view"}
                    className={"bg-blue-600 border-blue-600 text-white"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Mobile & desktop list of other programmes (includes first on mobile) */}
      <div className="flex flex-wrap gap-6 mt-10">
        {otherProgrammes &&
          otherProgrammes.length > 0 &&
          otherProgrammes.map((program, index) => (
            <div
              key={program?.id || index}
              className="w-full sm:w-[48%] lg:w-[30%]"
              onClick={() => navigate(`/programmes/${program?.id}`)}
            >
              <ProgrammeComponent program={program} />
            </div>
          ))}
      </div>
    </div>
  );
};

export default UpcomingPrograms;
